<template>
  <v-dialog v-model="value" persistent max-width="1000">
    <v-card>
      <v-layout>
        <v-flex></v-flex>
        <v-flex shrink>
          <v-btn flat fab small @click="onCancel">
            <v-icon> close </v-icon>
          </v-btn>
        </v-flex>
      </v-layout>

      <v-card-text>
        Campaign Name*
        <v-text-field
          name="name"
          id="name"
          single-line
          :error="errors.has('name')"
          :error-messages="errors.first('name')"
          autofocus
          flat
          v-model="data.name"
          class="default-input"
          outline
          v-validate="'required'"
        ></v-text-field>

        <v-layout row wrap class="default-input">
          <v-flex xs6 class="pr-1">
            Start Date
            <datepicker color="primary" v-model="data.start_date" @selected="onSelectedStartDate">
              <template v-slot="{ computedDate }">
                <v-text-field
                  name="date"
                  single-line
                  flat
                  :value="computedDate"
                  outline
                  id="id"
                  hide-details
                  disabled
                  class="custom-text-date-picker"
                ></v-text-field>
              </template>
            </datepicker>
          </v-flex>
          <v-flex xs6>
            End Date
            <datepicker color="primary" v-model="data.end_date" @selected="onSelectedEndDate">
              <template v-slot="{ computedDate }">
                <v-text-field
                  name="date"
                  single-line
                  flat
                  :value="computedDate"
                  outline
                  id="id"
                  hide-details
                  disabled
                  class="custom-text-date-picker"
                ></v-text-field>
              </template>
            </datepicker>
          </v-flex>
        </v-layout>

        Trigger After*
        <v-select
          name="trigger_after"
          id="trigger_after"
          data-vv-as="Trigger after"
          single-line
          :error="errors.has('trigger_after')"
          :error-messages="errors.first('trigger_after')"
          autofocus
          flat
          v-model="data.trigger_after"
          class="default-input"
          outline
          v-validate="'required'"
          :items="triggerAfterItems"
        ></v-select>

        <template v-if="data.trigger_after == 'บทสนทนา'">
          Conversation*
          <v-autocomplete
            name="intent"
            id="intent"
            data-vv-as="Conversation"
            single-line
            :error="errors.has('intent')"
            :error-messages="errors.first('intent')"
            autofocus
            flat
            v-model="data.intent"
            class="default-input"
            outline
            v-validate="'required'"
            :items="intentItems"
            item-value="id"
            item-text="intentname"
          ></v-autocomplete>
        </template>

        Messages*
        <v-layout row>
          <v-flex
            class="form-control"
            :class="{
              'has-error': errors.has('messages')
            }"
          >
            <autoresize-textarea
              ref="messages"
              name="messages"
              id="messages"
              data-vv-as="Messages"
              single-line
              :error="errors.has('messages')"
              :error-messages="errors.first('messages')"
              autofocus
              flat
              outline
              v-model="data.messages"
              maxlength="2000"
              v-validate="'required'"
              counter
              style="resize: none; display: inherit; margin-bottom: 5px"
            ></autoresize-textarea>
            <v-layout>
              <v-flex>
                <span class="text-error" v-show="errors.has('messages')">{{
                  errors.first('messages')
                }}</span>
              </v-flex>
              <v-flex shrink>{{ data.messages ? data.messages.length : 0 }}/2000</v-flex>
            </v-layout>

            <!-- <v-textarea></v-textarea> -->
          </v-flex>
          <v-flex shrink>
            <!-- <IntentPrefill :custom="customIntentPrefill" @addIntentPrefill="addPrefill"></IntentPrefill> -->
            <IntentPrefill @addIntentPrefill="addPrefill" :prefills="prefills"></IntentPrefill>
          </v-flex>
        </v-layout>

        Send Limit
        <v-text-field
          name="send_limit"
          id="send_limit"
          single-line
          :error="errors.has('send_limit')"
          :error-messages="errors.first('send_limit')"
          class="default-input"
          autofocus
          flat
          v-model="data.send_limit"
          outline
          @keypress="isNumber"
        ></v-text-field>

        Please select User
        <v-select
          name="limit_by_user"
          id="limit_by_user"
          single-line
          flat
          v-model="data.limit_by_user"
          class="default-input"
          outline
          :items="limitByOption"
        ></v-select>

        <div class="d-flex">
          <v-layout class="z-border-red pa-2">
            <v-flex class="d-flex">
              <div class="px-3 pt-3">จำนวนสิทธิ์ตลอดแคมเปญ</div>
              <v-text-field
                name="limit"
                id="limit"
                single-line
                :placeholder="$t('Count')"
                class="default-input"
                autofocus
                flat
                v-model="data.limit"
                outline
                @keypress="isNumber"
              ></v-text-field>
              <div class="px-3 pt-3">สิทธิ์</div>
            </v-flex>
          </v-layout>
          <v-layout class="z-border-red pa-2 ml-2">
            <v-flex style="display: flex">
              <div class="px-3 pt-3">จำกัดสิทธิ์ในการแลก</div>
              <v-text-field
                name="limit_period"
                id="limit_period"
                single-line
                :placeholder="$t('Count')"
                class="default-input"
                flat
                v-model="data.limit_period"
                outline
                @keypress="isNumber"
              ></v-text-field>
            </v-flex>
            <v-flex class="pl-3 d-flex">
              <div class="px-3 pt-3">/</div>
              <v-select
                name="period_type"
                id="period_type"
                data-vv-as="period_type"
                single-line
                flat
                v-model="data.period_type"
                class="default-input"
                outline
                :items="formatOption"
              ></v-select>
            </v-flex>
          </v-layout>
        </div>

        <div class="mt-3">
          Upload Codes {{ item && item.codes ? item.codes.length : 0 }} Code(s)
          <span v-if="codes" class="primary--text">(Replace code: {{ countAllCodes }} Codes)</span>
          <importxlsx :loading="loading" @onChange="onImport">
            <template v-slot="{ loading, onClickUploadButton }">
              <v-btn :loading="loading" @click="onClickUploadButton" outline color="primary">
                <em class="fas fa-file-upload mr-2" />Import
              </v-btn>
            </template>
          </importxlsx>
          <v-dialog
            v-model="showImportInfo"
            scrollable
            persistent
            max-width="500px"
            transition="dialog-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn icon small v-on="on"><v-icon color="primary">info</v-icon></v-btn>
            </template>
            <v-card>
              <v-card-title>
                <v-spacer></v-spacer>
                <v-btn small icon @click="showImportInfo = false"><v-icon>close</v-icon></v-btn>
              </v-card-title>
              <v-card-text>
                <strong>วิธีการ Import code เข้าไปในระบบ:</strong>

                <p>
                  User จะต้องทำการ import code โดยใช้ template excel ตามที่บริษัทได้มอบให้
                  เมื่อกดปุ่ม Import ที่หน้า Add campaign เรียบร้อย ให้ทำการเลือกไฟล์ template excel
                  ที่ได้กรอก code ที่จะใช้สำหรับ campaign แล้ว เมื่อเลือกไฟล์แล้ว ข้อมูล group code
                  และ จำนวน code จะแสดงผลที่หน้าจอให้
                </p>
                <p>
                  หลังจากนั้น ให้กลับไปที่ปุ่มจุด 3 จุดข้างช่องกรอกข้อความ เพื่อที่จะเพิ่ม function
                  ของ code ที่ได้มีการ import ไปก่อนหน้านี้ และ code
                  ก็จะแสดงผลที่ข้อความของลูกค้าได้อย่างที่ตั้งใจ
                </p>
                <p>
                  *Function code ที่แสดงอยู่ในปุ่มกดจุด 3 จุดนี้ จะอิงตาม group code ที่ user
                  ได้มีการใส่ข้อมูลเข้าไปในไฟล์และ import เข้าไปก่อนหน้านี้
                </p>
                <p>
                  *Function code จะแสดงผลขึ้นมาให้เห็นก็ต่อเมื่อได้มีการ import code
                  เข้าระบบเรียบร้อยเท่านั้น
                </p>

                <p>
                  หาก user ได้ import code และได้ insert function code เข้าไปในข้อความ
                  และกรอกข้อมูลส่วนอื่นเรียบร้อย ให้กดปุ่ม save เพื่อให้ follow-up message
                  นี้ได้เริ่มใช้งาน
                </p>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
        <template v-if="countCodes">
          <div v-for="(qty, code) in countCodes" :key="code">
            <span>{</span><span style="text-transform: lowercase">{{ code }}</span
            ><span>}</span> : {{ qty.count }} Code(s)
          </div>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn outline color="grey" @click="onCancel">
          {{ $t('cancel') }}
        </v-btn>
        <v-btn depressed color="primary" @click="onSave">
          {{ $t('Save') }}
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import datepicker from '@/components/elements/DatepickerCustomDialog'
import importxlsx from '@/components/elements/importxlsx.vue'
import { mapGetters } from 'vuex'
import IntentPrefill from '@/components/view/intent/IntentPrefill'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
export default {
  props: ['value', 'item'],
  data() {
    return {
      showStartDate: false,
      showEndDate: false,
      showImportInfo: false,
      data: {
        name: null,
        start_date: null,
        end_date: null,
        trigger_after: null,
        messages: null,
        limit: null,
        limit_by_user: null,
        limit_period: null,
        period_type: 'วัน',
        send_limit: null,
        codes: []
      },
      loading: false,
      triggerAfterItems: ['taxcert', 'รับผลประโยชน์', 'บทสนทนา'],
      formatOption: ['วัน', 'เดือน', 'ปี'],
      limitByOption: ['All', 'เคยสมัคร Line Connect', 'ไม่เคยสมัคร Line Connect'],
      codes: null,
      countCodes: [],
      countAllCodes: 0,
      customIntentPrefill: [],
      prefills: [
        {
          name: this.$t('Insert') + this.$t('first name'),
          value: 'first_name',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('last name'),
          value: 'last_name',
          description: ''
        }
      ]
    }
  },
  components: {
    datepicker,
    importxlsx,
    IntentPrefill,
    AutoresizeTextarea
  },
  async mounted() {
    if (this.item) this.data = this.item

    if (this.data.codes) {
      let allCodes = this.data.codes
      let countCode = {}
      allCodes.forEach((el) => {
        countCode[el.code_type] = countCode[el.code_type] || { count: 0 }
        countCode[el.code_type].count++
      })
      this.countCodes = { ...countCode }
      this.onGeneratePrefill(countCode)
    }
    await this.$nextTick()
    this.errors.clear()
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    intentItems() {
      return this.$store.getters.getIntents('intent')
        ? this.$store.getters.getIntents('intent')
        : []
    }
  },
  methods: {
    addPrefill(prefill) {
      // console.log(this.$refs['messages'], prefill)
      if (!this.$refs['messages']) return false
      let cursorPosition = this.$refs['messages'].$el.selectionStart
      // console.log(cursorPosition, this.$refs['messages'].$el.selectionStart)

      if (cursorPosition) {
        this.$set(
          this.data,
          'messages',
          [
            this.data.messages.slice(0, cursorPosition),
            '{' + prefill + '}',
            this.data.messages.slice(cursorPosition)
          ].join('')
        )
      } else {
        if (!this.data.messages) {
          this.$set(this.data, 'messages', [this.data.messages, '{' + prefill + '}'].join(''))
        } else {
          // this.$set(this.data, 'messages', [this.data.messages, '{' + prefill + '}'].join(''))
          this.$set(
            this.data,
            'messages',
            [this.data.messages.slice(0, 0), '{' + prefill + '}', this.data.messages].join('')
          )
        }
      }
    },
    onCancel() {
      this.onClose()
    },
    async onSave() {
      var result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      let data = _.cloneDeep(this.data)
      if (this.codes) {
        data.codes = this.codes
      }
      try {
        let endpoint = data.id ? 'putFollowMessage' : 'postFollowMessage'

        let response = await api[endpoint]({ pageid: this.selectedBot.pageid, data: data })

        if (response.status) {
          this.$emit('onSaveCampaign')
        }

        // this.$emit('onChange', response.status)
      } catch (error) {
        console.error(error)
      }
      this.onClose()
    },
    isNumber(value) {
      let val = null
      try {
        val = parseInt(value)
      } catch (error) {
        return false
      }
      return typeof val === 'number' && isFinite(val)
    },
    onClose() {
      this.$emit('input', false)
      this.$emit('onChange', null)
    },
    onSelectedStartDate(value, time) {
      if (moment(this.data.end_date).isBefore(value)) {
        this.data.end_date = value
      }
      if (!time) {
        this.data.start = value
      }
      this.showStartDate = false
    },
    onSelectedEndDate(value, time) {
      if (moment(value).isBefore(this.data.start_date)) {
        this.data.start_date = value
      }
      if (!time) {
        this.data.end_date = value
      }
      this.showEndDate = false
    },
    onImport(file) {
      let allCodes = file[0]
      let countCode = {}

      allCodes.forEach((el) => {
        Object.keys(el).forEach((key) => {
          countCode[key] = countCode[key] || { count: 0 }
          countCode[key].count++
          this.countAllCodes++
        })
      })

      this.onGeneratePrefill(countCode)
      this.countCodes = { ...countCode }
      this.codes = file[0]
    },
    onGeneratePrefill(code) {
      let customIntents = Object.keys(code)
      customIntents.forEach((intent) => {
        let obj = {}
        Object.assign(obj, {
          name: this.$t('Insert') + intent.toLowerCase(),
          value: intent.toLowerCase(),
          description: ''
        })
        this.prefills.push(obj)
      })

      // const customIntentPrefill = Object.keys(code);
      // this.customIntentPrefill = customIntentPrefill;
    }
  }
}
</script>

<style lang="scss">
.custom-text-date-picker input[type='text']:not(.browser-default):disabled {
  border-bottom: 0 !important;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/generalixwarroom/FollowupMessageManage.vue